import { render, staticRenderFns } from "./NewsGallery.vue?vue&type=template&id=45680441&"
import script from "./NewsGallery.js?vue&type=script&lang=js&"
export * from "./NewsGallery.js?vue&type=script&lang=js&"
import style0 from "./NewsGallery.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports